module.exports = __webpack_public_path__ + "static/react-svg-pan-zoom.7df14d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/react-svg-pan-zoom.png
// module id = 854
// module chunks = 73261030922168